export const heroHome = {
  id: "hero-home",
  title: "Autonomous Intelligent Robotics Lab",
  subtitle: "LSU New Orleans",
};

export const heroTeam = {
  id: "hero-team",
  title: "Current Team Members",
  subtitle:
    "We are a group of enthusiasts interested in Robotics, Machine Learning, Computer Vision and many more",
};

export const heroResearch = {
  id: "hero-research",
  title: "Research",
  subtitle:
    "Robots that learn from limited data, know what they do not know, and decide what to do next",
};

export const heroProjects = {
  id: "hero-projects",
  title: "Projects",
  subtitle: "Project websites with code, videos, and results",
};

export const heroFunding = {
  id: "hero-funding",
  title: "Funding",
  subtitle: "Supported by the NSF, EPA, and NIH",
};

export const heroAdvising = {
  id: "hero-advising",
  title: "Join Us",
  subtitle: "How I advise, and what to expect in the AiR Lab",
};

export const heroPublication = {
  id: "hero-publication",
  title: "Publications",
  subtitle:
    "Peer-reviewed work in IEEE RA-L, ICRA, IROS, T-ITS, and T-ASE",
};

export const heroContact = {
  id: "hero-contact",
  title: "Contact",
  subtitle: "Get in touch with us to talk about Robotics",
};

export const heroVideo = {
  id: "hero-video",
  title: "Video",
  subtitle: "Watch our latest videos",
}